import { apiWrapper } from '../utils/apiWrapper';
import axiosConfig from '../utils/axiosConfigInstance';
import axiosMuiltipartConfig from '../utils/axiosMultiPartConfigInstance';

export const fileUploadApi = async file => {
	const formData = new FormData();
	formData.append('file', file);
	return await apiWrapper(
		axiosMuiltipartConfig.post(`${import.meta.env.VITE_APP_API_URL}/common/file-upload`, formData)
	);
};

export const addTokenToMuxVideo = async (videoUrl) => {
	return await apiWrapper(
		axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/common/add-token-to-mux-video`, { videoUrl })
	);
}


export const fileUploadApis = {
	fileUploadApi
};
